module.exports = __webpack_public_path__ + "img/9788959894703.efc9fcba.jpg";